import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  Input,
  OnInit,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { SpecialProductInterface } from '@interfaces/products/special_product_interface';
import { ProductsService } from '@core/services/products/products.service';
import { ProductServiceParamsInterface } from '@interfaces/products/product_service_params_interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LnProductsCarouselComponent } from '@components/ln-products-carousel/ln-products-carousel.component';
import { GetSpecialProductsData } from '@interfaces/products/get_special_products_data';
import { ApiResponse } from '@interfaces/api/api.interface';
import { MenuActions } from '../../states/menu_actions';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-other-products-of-ln-home',
  imports: [LnProductsCarouselComponent, TranslocoPipe],
  templateUrl: './other-products-of-ln-home.component.html',
  styleUrl: './other-products-of-ln-home.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtherProductsOfLnHomeComponent implements OnInit {
  private readonly TAG = 'OtherProductsOfLnHomeComponent';
  products: WritableSignal<SpecialProductInterface[]> = signal<SpecialProductInterface[]>([]);
  private readonly MIN_PRODUCT_SIZE = 20;
  showSeeMore = computed(() => this.products().length >= this.MIN_PRODUCT_SIZE);
  pageNumber = 1;
  pageSize = 24;
  private productService = inject(ProductsService);
  private destroyRef = inject(DestroyRef);
  private menuActions = inject(MenuActions);
  @Input({ required: true }) artisanID!: Signal<string | undefined>;

  ngOnInit(): void {
    this.getProducts();
  }

  getProducts() {
    const queryParams: ProductServiceParamsInterface = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      priceOrder: 'desc',
      isPiezaUnica: false,
      first: this.artisanID(),
    };

    this.productService
      .getProducts(queryParams)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: ApiResponse<GetSpecialProductsData>) => {
          const productos = res.data.productos;
          this.products.set(productos);
        },
        error: err => {
          console.log(`${this.TAG} ${err}`);
        },
      });
  }

  navigateToAllSpecialProducts() {
    this.menuActions.navigateToAllSpecialProducts();
  }
}
